import { atom, selector } from 'recoil';
import { MoleculerListResult } from '../../@sprinx/knihovka-types';
import { ApiClient, canUseDom } from '../../@sprinx/react-after-razzle';
import { GlobalStateRegister } from '../../@sprinx/react-after-razzle/stateStore';
import { ShoppingCartProduct } from '../../api/shoppingCart';
import { apiClientState, isAuthenticatedState } from '../appState';
import { ShoppingCustomerContact } from '../shopping';
import { ShippingTransportLimit } from './shipmentType';

export * from './shipmentType';

export function getShippings(
  apiClient: ApiClient,
  customer: ShoppingCustomerContact,
  cartId: string,
): Promise<MoleculerListResult<any>> {
  return apiClient.post('/v1/shipping/list', { cartId, customer });
}

export const shippingsState = GlobalStateRegister.register(
  atom<Array<ShoppingCartProduct> | []>({
    key: 'shippings',
    default: [],
  }),
);

export function getShippingTransportLimits(apiClient: ApiClient): Promise<ShippingTransportLimit[]> {
  return apiClient.get<ShippingTransportLimit[], {}>('/v1/shipping/transport-limits', {});
}

export const shippingTransportLimitsQuery = selector<ShippingTransportLimit[]>({
  key: 'shippingTransportLimits',
  get: ({ get }) => {
    if (!canUseDom || !get(isAuthenticatedState)) return [];
    return getShippingTransportLimits(get(apiClientState));
  },
});
